import _ from 'lodash';

export default ({ formData, schema, uiSchema }) => {
  const newSchema = _.cloneDeep(schema);
  const newFormData = [];
  if (formData) {
    if (!newSchema.items.enum.includes(formData)) {
      newSchema.items.enum[0] = formData;
    }
    newFormData.push(formData);
  }
  return { schema: newSchema, uiSchema, formData: newFormData };
};



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/changeQuestionType/toCheckboxes/fromSelect.js